import { StatusPlugin } from './observations/plugins/status/status.plugin';
import { ObservationStatusComponent } from './observations/widgets/observation-status/observation-status.component';
import { OpenObservationsComponent } from './observations/widgets/open-observations/open-observations.component';
import { LocationObservationChartComponent } from './dashboards/pages/account/location-observation-chart/location-observation-chart.component';

export const Components = [
    StatusPlugin,
    ObservationStatusComponent,
    OpenObservationsComponent,
    LocationObservationChartComponent,
];



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/components.ts